import { useT } from '@/i18n';
import styles from './Share.module.css';
import shared from '@/pages/pages.module.css';

import { BackButton } from './BackButton';
import { Button } from './Button';
import { ArrowRightIcon, CheckIcon, CopyIcon } from './Icons';
import { TABS, wordingOf } from './shareWording';
import ui from './ui.module.css';

/**
 * The share screen before its link exists, while the bridge is being made in
 * the background: the same layout and words, a small spinner and “Creating a
 * secure link…” in the link field, the buttons resting. The live screen then takes its place without a jump.
 */
export function SharePending({ waiting = false, purpose = 'chat' }: { readonly waiting?: boolean; readonly purpose?: 'chat' | 'receive' }): React.JSX.Element {
  const t = useT();
  const words = wordingOf(waiting, purpose);
  return (
    <div className={styles.share} data-testid="share-pending" role="status" aria-label={t('sharePending.label')}>
      <div className={styles.shareHead}>
        <BackButton />
        <h2 className={shared.panelTitle}>{t(words.title)}</h2>
      </div>
      <div className={[ui.seg, styles.shareTabs].join(' ')} role="tablist" aria-hidden="true">
        {TABS.map((item) => (
          <button key={item.id} type="button" role="tab" className={ui.segTab} aria-selected={item.id === 'link'} disabled tabIndex={-1}>
            {item.icon}
            <span className={ui.segTabLabel} data-label={t(item.label)}>
              {t(item.label)}
            </span>
          </button>
        ))}
      </div>
      <div className={styles.sharePanel}>
        <p className={styles.shareLead}>{t(words.lead)}</p>
        <div className={[styles.linkBox, styles.linkBoxPending].join(' ')}>
          <span className={styles.linkText}>
            <span className={styles.linkSpinner} aria-hidden="true" />
            {t('sharePending.creating')}
          </span>
          <span className={styles.linkCopyBtn} aria-hidden="true">
            <CopyIcon size={20} />
          </span>
        </div>
        <p className={styles.shareWarn}>{words.warning}</p>
      </div>
      {words.wait !== null ? (
        <p className={styles.waiting}>
          <i aria-hidden="true" />
          {t(words.wait)}
        </p>
      ) : null}
      <div className={shared.shareFoot}>
        <Button className={styles.shareDone} disabled tabIndex={-1}>
          {t(words.close)}
          {waiting ? <ArrowRightIcon size={16} /> : <CheckIcon size={16} />}
        </Button>
      </div>
    </div>
  );
}

